import React, { useEffect, useRef, useState } from 'react';
import styles from './Me.module.css';

// תמונה של שירלי
import shirleyImage from '../../images/תמונת תדמית שירלי.jpg';

// תמונות המלצות
import testimonial1 from '../../images/שירלי המלצות 1.png';
import testimonial2 from '../../images/שירלי המלצות 2.png';

import testimonial4 from '../../images/שירלי המלצות 4.png';
import testimonial5 from '../../images/שירלי המלצות 5.png';
import testimonial6 from '../../images/שירלי המלצות 6.png';
import testimonial7 from '../../images/שירלי המלצות 7.png';

// CountUp Hook
const useCountUp = (end, duration = 2000, startOnView = true) => {
  const [count, setCount] = useState(0);
  const [hasStarted, setHasStarted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!startOnView) {
      animateCount();
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStarted) {
          setHasStarted(true);
          animateCount();
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [hasStarted, startOnView]);

  const animateCount = () => {
    const startTime = performance.now();
    
    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function (ease-out)
      const easeOut = 1 - Math.pow(1 - progress, 3);
      
      setCount(Math.floor(easeOut * end));
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };
    
    requestAnimationFrame(animate);
  };

  return { count, ref };
};

// CountUp Component
const CountUpStat = ({ end, suffix = '', label }) => {
  const { count, ref } = useCountUp(end, 2000);
  
  return (
    <div className={styles.statItem} ref={ref}>
      <span className={styles.statNumber}>{count}{suffix}</span>
      <span className={styles.statLabel}>{label}</span>
    </div>
  );
};

const magazines = [
  {
    id: 1,
    name: 'WALLS',
    title: 'דירת מחיר למשתכן',
    url: 'https://wallsmag.co.il/%D7%A9%D7%99%D7%A8%D7%9C%D7%99-%D7%92%D7%95%D7%9C%D7%93%D7%A9%D7%98%D7%99%D7%99%D7%9F-%D7%93%D7%99%D7%A8%D7%AA-%D7%9E%D7%97%D7%99%D7%A8-%D7%9C%D7%9E%D7%A9%D7%AA%D7%9B%D7%9F/',
  },
  {
    id: 2,
    name: 'WALLS',
    title: 'עיצוב פנים',
    url: 'https://wallsmag.co.il/%D7%A9%D7%99%D7%A8%D7%99-%D7%92%D7%95%D7%9C%D7%93%D7%A9%D7%98%D7%99%D7%99%D7%9F-%D7%A2%D7%99%D7%A6%D7%95%D7%91-%D7%A4%D7%A0%D7%99%D7%9D/',
  },
  {
    id: 3,
    name: 'WALLS',
    title: 'בניית בית פרטי',
    url: 'https://wallsmag.co.il/%D7%91%D7%A0%D7%99%D7%99%D7%AA-%D7%91%D7%99%D7%AA-%D7%A4%D7%A8%D7%98%D7%99-%D7%A9%D7%99%D7%A8%D7%9C%D7%99-%D7%92%D7%95%D7%9C%D7%93%D7%A9%D7%98%D7%99%D7%99%D7%9F/',
  },
  {
    id: 4,
    name: 'WALLS',
    title: 'עיצוב ותכנון בית פרטי',
    url: 'https://wallsmag.co.il/%D7%A2%D7%99%D7%A6%D7%95%D7%91-%D7%95%D7%AA%D7%9B%D7%A0%D7%95%D7%9F-%D7%91%D7%99%D7%AA-%D7%A4%D7%A8%D7%98%D7%99-%D7%A9%D7%99%D7%A8%D7%9C%D7%99-%D7%92%D7%95%D7%9C%D7%93%D7%A9%D7%98%D7%99%D7%99%D7%9F/',
  },
  {
    id: 5,
    name: 'PNIM',
    title: 'הבית של הודיה ועוזיה',
    url: 'https://www.pnim.co.il/%D7%94%D7%91%D7%99%D7%AA-%D7%A9%D7%9C-%D7%94%D7%95%D7%93%D7%99%D7%94-%D7%95%D7%A2%D7%95%D7%96%D7%99%D7%94-%D7%91%D7%90%D7%A9%D7%A7%D7%9C%D7%95%D7%9F/',
  },
  {
    id: 6,
    name: 'PNIM',
    title: 'הבית של הילה בראשון',
    url: 'https://www.pnim.co.il/%D7%94%D7%91%D7%99%D7%AA-%D7%A9%D7%9C-%D7%94%D7%99%D7%9C%D7%94-%D7%91%D7%A8%D7%90%D7%A9%D7%95%D7%9F-%D7%9C%D7%A6%D7%99%D7%95%D7%9F/',
  },
  {
    id: 7,
    name: 'PNIM',
    title: 'פרופיל מעצבת',
    url: 'https://www.pnim.co.il/%D7%A9%D7%99%D7%A8%D7%9C%D7%99-%D7%92%D7%95%D7%9C%D7%93%D7%A9%D7%98%D7%99%D7%99%D7%9F/',
  },
];

const testimonialImages = [
  testimonial1,
  testimonial2,

  testimonial4,
  testimonial5,
  testimonial6,
  testimonial7,
];

// Testimonial Item Component with reveal effect
const TestimonialItem = ({ img, index }) => {
  const itemRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // Add delay based on index for staggered effect
          setTimeout(() => {
            setIsVisible(true);
          }, index * 100);
        }
      },
      { threshold: 0.2 }
    );

    if (itemRef.current) {
      observer.observe(itemRef.current);
    }

    return () => observer.disconnect();
  }, [index]);

  return (
    <div 
      ref={itemRef} 
      className={`${styles.testimonialItem} ${isVisible ? styles.visible : ''}`}
    >
      <img 
        src={img} 
        alt={`המלצה ${index + 1}`}
        className={styles.testimonialImage}
        loading="lazy"
      />
    </div>
  );
};

const AboutMe = () => {
  const sectionRef = useRef(null);
  const contentRef = useRef(null);
  const imageRef = useRef(null);
  const magazinesRef = useRef(null);
  const testimonialsRef = useRef(null);

  // WhatsApp link
  const getWhatsAppLink = () => {
    const phoneNumber = '972543324747';
    const message = encodeURIComponent('היי שירלי, אשמח לשיחת ייעוץ ראשונית');
    return `https://wa.me/${phoneNumber}?text=${message}`;
  };

  // Intersection Observer for fade-in animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.visible);
          }
        });
      },
      { threshold: 0.15 }
    );

    if (contentRef.current) observer.observe(contentRef.current);
    if (imageRef.current) observer.observe(imageRef.current);
    if (magazinesRef.current) observer.observe(magazinesRef.current);
    if (testimonialsRef.current) observer.observe(testimonialsRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className={styles.aboutSection} id="about">
      {/* Background Decoration */}
      <div className={styles.bgDecoration}>
        <div className={styles.decorLine1}></div>
        <div className={styles.decorLine2}></div>
      </div>

      <div className={styles.container}>
        {/* Content Side - Right */}
        <div ref={contentRef} className={styles.contentSide}>
          {/* Main Title */}
          <h2 className={styles.title}>
            נעים מאוד <br/> שירלי גולדשטיין
          </h2>

          {/* Subtitle */}
          <p className={styles.subtitle}>
            <strong>מעצבת פנים ואדריכלית</strong>
          </p>

          {/* Divider */}
          <div className={styles.divider}>
            <span className={styles.dividerDot}></span>
            <span className={styles.dividerLine}></span>
            <span className={styles.dividerDot}></span>
          </div>

          {/* Story Paragraphs */}
          <div className={styles.storyContent}>
            <p className={styles.paragraph}>
              אני חיה ונושמת עיצוב מאז ומתמיד. זו שליחות, כמה שזה נשמע קלישאתי.
              הדבר שהכי מרגש אותי הוא לפצח חלל מבחינה תכנונית - לקחת דירה או בית 
              ולהפוך אותם למקום שבאמת מותאם לחיים של המשפחה שגרה בו.
            </p>

            <div className={styles.miniDivider}>
              <span></span>
              <span></span>
              <span></span>
            </div>

            <p className={styles.paragraph}>
              אחרי עשר שנים של התמחות בתכנון דירות, אני יודעת שתכנון נכון הוא הבסיס לכל בית מוצלח.
              בלי תכנון - יש בלאגן, חוסר ניצול של המרחב, וחוסר שקט. 
              כשהתכנון נכון, הבית פשוט עובד.
            </p>

            <div className={styles.miniDivider}>
              <span></span>
              <span></span>
              <span></span>
            </div>

            <p className={styles.paragraph}>
              אני מאמינה שאין יפה בלי פרקטי. 
              המטרה שלי היא לעצב לכל לקוח את הבית כמו כפפה ליד - 
              בדיוק לפי הצרכים, ההרגלים והחלומות שלו.
            </p>

            <div className={styles.miniDivider}>
              <span></span>
              <span></span>
              <span></span>
            </div>

            <p className={styles.paragraph}>
            
              אני יודעת לעבוד עם כל תקציב - ואפילו נהנית יותר מהאתגר של תקציבים מוגבלים.
              מרקטפלייס, יד 2, עלי אקספרס - הכל כלי עבודה לגיטימי כשיודעים איך להשתמש בהם נכון.
            </p>

            <p className={styles.highlightText}>
              כל סנטימטר בבית צריך לעבוד בשבילך <br/>כל שקל בתקציב צריך להיות מושקע נכון.
            </p>
          </div>

          {/* CTA Button */}
          <div className={styles.ctaWrapper}>
            <a 
              href={getWhatsAppLink()} 
              target="_blank" 
              rel="noopener noreferrer"
              className={styles.ctaButton}
            >
              <span className={styles.ctaText}>בואו נדבר על הבית שלכם</span>
              <span className={styles.ctaArrow}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M19 12H5M12 5l-7 7 7 7"/>
                </svg>
              </span>
            </a>
          </div>
        </div>

        {/* Image Side - Left */}
        <div ref={imageRef} className={styles.imageSide}>
          <div className={styles.imageWrapper}>
            {/* Decorative Frame */}
            <div className={styles.imageFrame}></div>
            
            {/* Main Image */}
            <div className={styles.imageContainer}>
              <img 
                src={shirleyImage} 
                alt="שירלי גולדשטיין - מעצבת פנים" 
                className={styles.image}
              />
            </div>

            {/* Decorative Corners */}
            <div className={styles.decorCorner} data-position="top-right"></div>
            <div className={styles.decorCorner} data-position="bottom-left"></div>
          </div>

          {/* Stats - Under Image */}
          <div className={styles.stats}>
            <CountUpStat end={10} suffix="+" label="שנות ניסיון" />
            <div className={styles.statDivider}></div>
            <CountUpStat end={60} suffix="+" label="משפחות כבר בבית החלומות שלהם" />
          </div>
        </div>
      </div>

      {/* ========================================
          Magazines Section - Centered
      ======================================== */}
      <div ref={magazinesRef} className={styles.magazinesSection}>
        <div className={styles.magazinesInner}>
          {/* Title */}
          <h3 className={styles.magazinesTitle}>
            הפרויקטים שלי התפרסמו ב:
          </h3>

          {/* Magazines List */}
          <div className={styles.magazinesList}>
            {magazines.map((magazine) => (
              <a
                key={magazine.id}
                href={magazine.url}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.magazineItem}
              >
                <span className={styles.magazineName}>{magazine.name}</span>
                <span className={styles.magazineTitle}>{magazine.title}</span>
              </a>
            ))}
          </div>

          {/* Description */}
          <p className={styles.magazinesDescription}>
            אמנם הפרויקטים שלי התפרסמו במגזיני עיצוב מובילים - וזו הגושפנקה הכי טובה שאני יכולה לקבל על העבודה שלי.
            אבל מה שהכי חשוב לי? <strong>הלקוחות שנכנסים לבית החדש שלהם ומרגישים שהוא באמת שלהם.</strong>
          </p>
        </div>
      </div>

      {/* ========================================
          Testimonials Section
      ======================================== */}
      <div ref={testimonialsRef} className={styles.testimonialsSection}>
        <div className={styles.testimonialsInner}>
          {/* Title */}
          <h3 className={styles.testimonialsTitle}>
            וזה מה שיש להם לומר בסוף התהליך:
          </h3>

          {/* Testimonials Grid */}
          <div className={styles.testimonialsGrid}>
            {testimonialImages.map((img, index) => (
              <TestimonialItem key={index} img={img} index={index} />
            ))}
          </div>

          {/* CTA Button */}
          <div className={styles.testimonialsCta}>
            <a 
              href={getWhatsAppLink()} 
              target="_blank" 
              rel="noopener noreferrer"
              className={styles.mainCtaButton}
            >
              <span className={styles.mainCtaText}>שירלי, בואי נדבר!</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;